/// <reference path="../../../common/common/common.ts" />
/// <reference path="../../../common/resources/resources.ts" />

namespace OfficeGuy.Inputs {
    export class File {
        static ConsoleLogged = false;
        static Init() {
            $(document)
                .on("dragenter", ".sumit-input-file", function (Event) {
                    Event.preventDefault();
                    Event.stopPropagation();
                })
                .on("dragover", ".sumit-input-file", function (Event) {
                    Event.preventDefault();
                    Event.stopPropagation();
                })
                .on("drop", ".sumit-input-file", function (Event) {
                    if (Event.originalEvent.dataTransfer && Event.originalEvent.dataTransfer.files.length) {
                        Event.preventDefault();
                        Event.stopPropagation();
                        $(this).closest(".sumit-input-file").prev("input[type=file]").prop("files", Event.originalEvent.dataTransfer.files).trigger("change");
                    }
                });
        }
        static InitEditors(Container?, Options?) {
            return $("input[type=file]:not(.sumit-input-file-init)", Container).each(function () {
                if (!File.ConsoleLogged) {
                    var MobileApplication = Teva.Storage.Cookie_Get("X-OG-Mobile");
                    if (MobileApplication == "Android" || MobileApplication == "iPhone")
                        console.log("OG_InputFile");
                }
                var Defaults = {
                    Extensions: null,
                    width: 300,
                    OnChange: null
                };

                Options = $.extend(Defaults, Options);

                var $Input = $(this);
                var $DeleteFileInput = $Input.next("[name$=DeleteFile]");
                $Input.addClass("sumit-input-file-init");

                var $Container = $("<div>")
                    .addClass("sumit-input-file")
                    .addClass($Input.is(":disabled, [readonly='readonly']") ? " sumit-input-file-disabled" : "");

                var $Filename = $("<div>")
                    .addClass("sumit-input-file-filename")
                    .addClass("using-tooltip")
                    .attr("title", OfficeGuy.Resources.GetString("CRM", "ChooseFile"))
                    .text(OfficeGuy.Resources.GetString("CRM", "ChooseFile"));

                var $Delete = $("<div>")
                    .addClass("sumit-input-file-delete")
                    .addClass("using-tooltip")
                    .attr("title", "מחיקה");

                var $Download = $("<div>")
                    .addClass("sumit-input-file-download")
                    .addClass("using-tooltip")
                    .attr("title", "הורדה");

                if ($Input.attr("data-existingfileurl")) {
                    $Container.addClass("sumit-input-file-populated");
                    $Filename.text($Input.attr("data-existingfilename"));
                }

                $Container.insertAfter($Input);
                $Filename.appendTo($Container);
                $Delete.appendTo($Container);
                $Download.appendTo($Container);
                $Input.hide();

                if ($Input.is(":disabled")) {
                    $Container.addClass(".sumit-input-file-disabled");
                    return;
                }

                $Filename.on("click", function () {
                    $Input.trigger("click");
                    return false;
                });
                $Delete.on("click", function () {
                    $Input.val("").trigger("change");
                    $DeleteFileInput.val("true");
                    return false;
                });
                $Download.on("click", function () {
                    if ((<any>$Input[0]).files.length == 0)
                        OfficeGuy.Navigation.DownloadAsync($Input.attr("data-existingfileurl"));
                    else {
                        for (var i = 0; i < (<any>$Input[0]).files.length; i++) {
                            var File = (<any>$Input[0]).files[i];
                            var blobUrl = URL.createObjectURL(new Blob([File]));
                            var link = <any>document.createElement("a");
                            link.href = blobUrl;
                            link.download = File.name;

                            document.body.appendChild(link);
                            link.dispatchEvent(new MouseEvent('click', {
                                bubbles: true,
                                cancelable: true,
                                view: window
                            }));

                            document.body.removeChild(link);
                        }
                    }
                    return false;
                });

                $Input.bind("change", function () {
                    var Files = (<any>$(this)[0]).files;
                    $Container.toggleClass("sumit-input-file-populated", Files.length > 0);
                    if (Files.length == 0) {
                        $Filename.text("בחירת קובץ");
                        $Container
                            .removeClass("sumit-input-file-error")
                            .removeClass("sumit-input-file-valid");
                    }
                    else {
                        var InvalidExtensions = false;
                        for (var i = 0; i < Files.length; i++)
                            if (!IsAllowedExtension(Files[i].name))
                                InvalidExtensions = true;
                        if (InvalidExtensions) {
                            $Input.val("");
                            $Container
                                .removeClass("sumit-input-file-valid")
                                .addClass("sumit-input-file-error");
                        }
                        else {
                            if (Files.length > 1)
                                $Filename.text(Files.length + ' קבצים');
                            else
                                $Filename.text(Files[0].name);
                            if (Options.OnChange)
                                Options.OnChange();
                            $Container
                                .removeClass("sumit-input-file-error")
                                .addClass("sumit-input-file-valid");
                        }
                    }
                })

                function IsAllowedExtension(Filename) {
                    if (!Options.Extensions)
                        return true;

                    var Extension = Filename === undefined ? "" : Filename.split(".").pop();
                    if (Extension == '')
                        return true;

                    return $.inArray(Extension, Options.Extensions) !== -1;
                }
            });
        };
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.Inputs.File.Init();
});
$(document).on("Teva.InitEditors", function (Event, Container) {
    OfficeGuy.Inputs.File.InitEditors(Container);
});